import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg text-foreground-950">
                我爱漫画网<span className="text-primary-600">.</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              漫画迷必备的追更收藏站。收藏漫画、连载更新提醒、追漫日历、进度保存，一部不落，不错过每一话。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-3">
              <li><Link to="/comics" className="text-sm text-foreground-600 hover:text-primary-600">漫画库</Link></li>
              <li><Link to="/calendar" className="text-sm text-foreground-600 hover:text-primary-600">追漫日历</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-600">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">热门分类</h3>
            <ul className="mt-4 space-y-3">
              <li><Link to="/comics" className="text-sm text-foreground-600 hover:text-primary-600">热血冒险</Link></li>
              <li><Link to="/comics" className="text-sm text-foreground-600 hover:text-primary-600">科幻奇幻</Link></li>
              <li><Link to="/comics" className="text-sm text-foreground-600 hover:text-primary-600">恋爱日常</Link></li>
              <li><Link to="/comics" className="text-sm text-foreground-600 hover:text-primary-600">悬疑惊悚</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line"></i> hello@woaimanhua.example
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-chat-3-line"></i> 站长交流群
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-global-line"></i> 全年无休 · 追更不打烊
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 我爱漫画网 · 本站仅作追更收藏与更新提醒服务</p>
          <div className="flex gap-4">
            <a href="#" aria-label="社交平台" className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" aria-label="社交平台" className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50">
              <i className="ri-bilibili-line"></i>
            </a>
            <a href="#" aria-label="社交平台" className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50">
              <i className="ri-wechat-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}